<template>
  <footer class="Footer">

    <a href="https://kerialis.fr/mentions-legales/" target="_blank">Mentions Légales</a>
    <inertia-link :href="route('cgu')">CGU</inertia-link>

    <a href="#" @click.prevent="ModalesManager.open(contactModal)">Contactez-nous</a>
    <a id="hs-cookie-settings-link" @click.prevent="openCookies" >Cookies</a>
    <a href="https://kerialis.fr/politique-des-cookies/" target="_blank">Politique des cookies</a>
    <a href="https://kerialis.fr/protection-des-donnees-a-caractere-personnel/" target="_blank">Protection des données</a>


    <ExternalButtonLink href="https://kerialis.fr/" class="is--min is--green">
      KERIALIS.FR
    </ExternalButtonLink>

  </footer>
</template>

<script>
import { ModalesManager } from '@/store/modales'
import ExternalButtonLink from "@components/navigation/ExternalButtonLink";
import ExternalLink from "@components/navigation/ExternalLink.vue";

export default {
  props: {
    contactModal: {
      type: String,
      default: 'contact'
    }
  },
  components: {
    ExternalLink,
    ExternalButtonLink,
  },
  setup() {

    const openCookies = () => {
      const _hsp = window._hsp = window._hsp || [];
      _hsp.push(['showBanner'])
    }

    return {
      openCookies,
      ModalesManager
    }
  }
}
</script>

<style lang="scss">
  @import "~@sass/components/_Footer.scss";
</style>
